function getWishList() {
  try {
    return JSON.parse(localStorage.getItem('wishList')) || [];
  } catch (e) {
    return [];
  }
}

function saveWishList(list) {
  localStorage.setItem('wishList', JSON.stringify(list.slice(0, 20)));
}

class ProductWishlist extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('data-productID');
    this.checkActiveWishlist();
    this.addEventListener('click', this.onEventWishlist.bind(this));

    window.addEventListener('storage', (e) => {
      if (e.key === 'wishList') {
        this.checkActiveWishlist();
      }
    });
  }

  onEventWishlist() {
    const currentList = getWishList();
    const index = currentList.indexOf(this.productId);
    if (index > -1) {
      this.classList.remove('wishlist_added');
      currentList.splice(index, 1);
    } else {
      this.classList.add('wishlist_added');
      currentList.push(this.productId);
    }
    saveWishList(currentList);
  }

  checkActiveWishlist() {
    const currentList = getWishList();
    if (currentList.indexOf(this.productId) > -1) {
      this.classList.add('wishlist_added');
    } else {
      this.classList.remove('wishlist_added');
    }
  }
}

customElements.define('wish-list-icon', ProductWishlist);

class ProductWishlistTemplate extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute('section-id');
  }

  async connectedCallback() {
    const wishList = getWishList();
    if (wishList.length === 0) return;

    const fetchPromises = wishList.map((id) =>
      fetch(`${window.routes.urlSearch}?type=product&q=id:${id}&section_id=${this.sectionId}`)
        .then((res) => res.text())
        .then((html) => {
          const div = document.createElement('div');
          div.innerHTML = html;
          const template = div.querySelector('product-wishlist-template');
          if (!template) return [];
          return Array.from(template.querySelectorAll('.grid__item'));
        })
        .catch(() => [])
    );

    const results = await Promise.all(fetchPromises);
    const allItems = results.flat().filter(Boolean);

    if (allItems.length === 0) return;

    const grid = this.querySelector('ul.product-grid');
    if (grid) {
      grid.innerHTML = '';
      allItems.forEach((item) => grid.appendChild(item));
    } else {
      const ul = document.createElement('ul');
      ul.className = 'grid product-grid grid--4-col-desktop grid--2-col-tablet-down';
      ul.setAttribute('role', 'list');
      allItems.forEach((item) => ul.appendChild(item));
      this.innerHTML = '';
      this.appendChild(ul);
    }
  }
}

customElements.define('product-wishlist-template', ProductWishlistTemplate);